import { useEffect, useRef, useState } from 'react'

// These legacy lists share a store with smaller lookup requests. Wait for the
// page's full request rather than treating any stored rows as a complete list.
const useListLoad = (api, url, onLoaded) => {
    const onLoadedRef = useRef(onLoaded)
    const [state, setState] = useState({ isLoading: true, isError: null })
    useEffect(() => { onLoadedRef.current = onLoaded }, [onLoaded])
    useEffect(() => {
        let cancelled = false
        const load = async () => {
            setState({ isLoading: true, isError: null })
            try {
                const [error, response] = await api.get(url)
                if (cancelled) return
                if (!error) onLoadedRef.current(response.data)
                setState({ isLoading: false, isError: error || null })
            } catch (error) {
                if (!cancelled) setState({ isLoading: false, isError: error })
            }
        }
        load()
        return () => { cancelled = true }
    }, [api, url])
    return state
}

export default useListLoad
